import useObservedDelta from './use-observed-delta';

export const useResetScrollOnChange = (value: any) => {
  useObservedDelta(value, () => {
    window.scrollTo(0, 0);
  });
};

export default useResetScrollOnChange;
